import axios from 'axios';
import { globalConfig } from '../settings/global.config';

const setupAppFont = (fontName, fontLocation) => {
	const link = document.createElement('link');
	link.id = fontName;
	link.rel = 'stylesheet';
	link.type = 'text/css';
	link.href = globalConfig.configuration.environment.apiBasePath + fontLocation;
	link.media = 'all';
	const head = document.getElementsByTagName('head')[0];
	head.appendChild(link);
};

export const settings = {
	PathBase: globalConfig.configuration.environment.apiBasePath,
	BaseUrl: `${globalConfig.configuration.environment.apiBasePath}api/`
};

export const auth0settings = {
	domain: globalConfig.configuration.auth0.domain,
	clientId: globalConfig.configuration.auth0.clientId,
	redirectUri: globalConfig.configuration.auth0.redirectUri,
	audience: globalConfig.configuration.auth0.audience,
	scope: 'openid profile email healthsuite',
	maxAge: globalConfig.configuration.auth0.maxAge,
	cacheLocation: 'localstorage',
	useRefreshTokens: true,
	options: {
		enable_passwordless: false,
		allowForgotPassword: true,
		allowSignUp: true,
		allowLogin: true
	}
};

export const instance = axios.create({
	baseURL: settings.BaseUrl,
	responseType: 'json',
	headers: {
		'Content-Type': 'application/json'
	}
});

export const cacheHeaders = {
	'Content-Type': 'application/json',
	'Cache-Control': 'no-cache, no-store, must-revalidate',
	Pragma: 'no-cache',
	Expires: '0'
};

export const rowsInPopup = 10;

setupAppFont('roboto', '/products/resources/fonts/roboto/roboto.css');
setupAppFont('allocate-icons', '/products/resources/fonts/allocate-icons/allocate-icons.css');
